var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools02-pointback"},[_c('el-row',[_c('el-col',[(_vm.tool.codeKebab === 'cart-system')?_c('h2',[_vm._v("カート/計測システム自動連携設定")]):_c('h2',[_vm._v("ASP自動連携設定")])])],1),_c('el-row',[_c('el-col',[_c('Tools02PointBackAutoImportTags')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }